import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './permission'
// 引入echarts
import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts
import ECharts from 'vue-echarts'
import "echarts";
import './assets/icon/iconfont.css'
Vue.component('v-chart', ECharts)
Vue.use(ElementUI);
Vue.config.productionTip = false



new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')